import React, { Component } from 'react';
import styles from '../../../Assets/CSS/stylesheet_UHS';
import Grid from '@material-ui/core/Grid';
import Config from '../../../configurations';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';
import axios from "axios";
import configuration from "../../../configurations";
import Loader from "../../loader";
import Configuration from "../../../configurations";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class Header extends Component {
    constructor(props) {
        super(props);
        this.headerRef = React.createRef();
        this.state = {
            isLogged: false,
            loaderShow : false,
            association_logo : null,
            isAgent : sessionStorage.getItem('isAgent'),
            salesCloud: sessionStorage.getItem('salesCloud'),
            fromMember:false,
            carrier: null,
            headerHeight: 0,
        };
    }

    measureHeader = () => {
        if(this.headerRef.current){
            this.setState({headerHeight: this.headerRef.current.offsetHeight});
        }
    }

    // STATE_PARAM.carrier can change after this header has already mounted (e.g. the member
    // clicks ENROLL against a different product in the Enrollments summary), so this is called
    // from componentDidUpdate too, not just componentDidMount, to pick that up.
    refreshCarrierFromSession = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'));
        if (cookiesData && cookiesData.carrier) {
            let carrier = cookiesData.productName ? cookiesData.productName.replaceAll("Sharing Programs", "UHS Sharing Programs") : (cookiesData.actionType
                ? cookiesData.actionType.replaceAll("_", " ").replaceAll(/\b\w/g, char => char.toUpperCase())
                : cookiesData.carrier.replaceAll("Sharing Programs", "UHS Sharing Programs"));
            if (carrier !== this.state.carrier) {
                this.setState({ carrier });
            }
        } else if (this.state.carrier !== null) {
            this.setState({ carrier: null });
        }
    };

    componentDidMount() {
        this.state.isLogged = sessionStorage.getItem('isLogged');
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'))//cookies.get('STATE_PARAM', false);

        this.measureHeader();
        window.addEventListener('resize', this.measureHeader);

        if(cookiesData && cookiesData.fromMember){
            this.setState({fromMember:true})
        }

        this.refreshCarrierFromSession();

        let data={
            "clientId" : sessionStorage.getItem('CLIENT_ID')
        }
        console.log('----------------------------------')
        console.log(data.clientId)
        this.setState({
            isAgent : sessionStorage.getItem('isAgent') ? sessionStorage.getItem('isAgent') : false
        });
        axios.post(Configuration.baseUrl+'/enrollment/getClient',data)
            .then(response=>{
                if(response.data.response){
                    this.setState({
                        association_logo : response.data.response.image
                    });
                }
            });

    }

    componentDidUpdate(prevProps, prevState) {
        this.refreshCarrierFromSession();
        if(prevState.carrier !== this.state.carrier || prevState.association_logo !== this.state.association_logo){
            this.measureHeader();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.measureHeader);
    }

    logoutHandler = (event) => {
      
                    Auth.signOut();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem('isLogged', false);
                    sessionStorage.setItem('isLogged', false);
                    window.location.href = '/login';
           
         
    }
    handleClose=()=>{
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')).fromNative
        if(cookiesData){
            this.logoutHandler()//for native mobile APP 
        }else{
            window.close();
        }
    }

    goToDashboard = () =>{
        this.setState({
            loaderShow: true
        });

        let currentScreen = sessionStorage.getItem('current_screen');

        // if(sessionStorage.getItem('prev_current_screen') || sessionStorage.getItem('prev_current_screen') != null ){
        //     currentScreen = sessionStorage.getItem('prev_current_screen')
        // }        
        
        if(sessionStorage.getItem('isEditCensus') == true || sessionStorage.getItem('isEditCensus') == 'true'){
            window.close();
        }else if(currentScreen){
            axios.get(configuration.baseUrl + '/enrollment/saveCompletionStatus/' + this.props.subId + '/' + currentScreen)
                .then(response => {
                    if (response && response.data.code === 200) {
                        sessionStorage.removeItem('STATE_PARAM');
                        sessionStorage.removeItem('STATE_VAL');
                        sessionStorage.removeItem('CLIENT_ID');
                        sessionStorage.removeItem('CHAT_BOX_Id');
                        cookies.remove("STATE_PARAM", { path: '/' });
                        window.close();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            window.close();
        }

    }

    signUpHandler = () => {
        sessionStorage.removeItem('CHAT_BOX_Id');
        sessionStorage.removeItem('CLIENT_ID');
        window.location.href = '/signup' + window.location.hash;
    }

    loginHandler = () => {
        sessionStorage.removeItem('CHAT_BOX_Id');
        sessionStorage.removeItem('CLIENT_ID');
        window.location.href = '/login' + window.location.hash;
    }

    render() {
        let currentScreen = '';
        this.state.isLogged = sessionStorage.getItem('isLogged');
        if (this.state.isLogged === 'true' || this.state.isLogged === true || this.state.isAgent === "true" || this.state.isAgent === true || this.state.fromMember == true) {
            if(window.location.pathname === "/quick_quote" || window.location.pathname === '/quick_quote2'){
                currentScreen = <div style={styles.LoginWrp}>
                    <div style={styles.HeaderWrp}>
                        <Grid xs={6} style={styles.HeaderRightWrp} item={true}>
                        <span style={styles.goToDashboardBtn} onClick={this.loginHandler}>LOGIN</span>
                            {/* <span style={styles.LoginRight}>Quick Quote</span> */}
                        </Grid>
                        <Grid xs={6} style={styles.HeaderLeftWrp} item={true}>
                            {
                                (this.state.isAgent === "false" || this.state.isAgent === false) &&
                                <div style={{display : 'inline-flex'}}>
                                    <span style={styles.LoginLeft} onClick={this.loginHandler}>LOGIN</span>
                                    <span style={styles.LoginLeft} onClick={this.signUpHandler}>SIGN UP</span>
                                </div>
                            }
                        </Grid>
                    </div>
                </div>
            } else {
                currentScreen = <div >
                    <div style={styles.HeaderWrp}>
                        <Grid  style={styles.HeaderLeftWrp} item={true}>
                            {
                                (this.state.isAgent === "true" || this.state.isAgent === true)  ?
                                    <span style={styles.goToDashboardBtn} onClick={this.goToDashboard}>BACK TO DASHBOARD</span>
                                    :
                                    this.state.fromMember == true?
                                    <span style={styles.goToDashboardBtn} onClick={this.handleClose}>CLOSE</span>
                                    :
                                    <span style={styles.goToDashboardBtn} onClick={this.logoutHandler}>LOGOUT</span>
                            }
                        </Grid>
                    </div>
                </div>
            }
        } else if(window.location.pathname === "/quick_quote" || window.location.pathname === '/quick_quote2'){
            currentScreen = <div>
                <div>
                   
                    <Grid xs={6}  item={true}>
                        {
                            (this.state.isAgent === "false" || this.state.isAgent === false || !this.state.salesCloud) &&
                                <div style={{display : 'inline-flex'}}>
                                    <span style={styles.goToDashboardBtn} onClick={this.loginHandler}>LOGIN</span>
                                   {/*  <span style={styles.LoginLeft} onClick={this.signUpHandler}>SIGN UP</span> */} {/* Hide for Temperary */}
                                </div>
                        }
                    </Grid>  
                </div>
            </div>
        }


        return (
            <div>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                <div style={styles.HeaderFixedWrp} ref={this.headerRef}>
                    <div style={{ padding: 8 }}>
                        <div style={styles.HeaderWrp}>
                            <Grid style={styles.HeaderBrandGroup} item={true}>
                                <img style={styles.HeaderRightLogo} src={require('../../../Assets/Images/logo.png')} />
                               
                            </Grid>
                             <Grid style={styles.HeaderBrandGroup} item={true}>
 {
                                 this.props.showEnrollmentSummary && sessionStorage.getItem("isLogged") == "true"? "":   this.state.carrier && 
                                    <span style={styles.EnrollingIntoWrp}>
                                        <span style={styles.EnrollingIntoLabel}>ENROLLING INTO:</span>
                                        <span style={styles.EnrollingIntoValue}>{this.state.carrier.toUpperCase()}</span>
                                    </span>
                                }
                             </Grid>
                            <Grid style={styles.HeaderControlsGroup} item={true}>
                                <span style={{display: "flex", alignItems: "center"}}>
                                    {currentScreen}
                                </span>
                             
                            </Grid>
                        </div>
                    </div>
                </div>
                <div style={{ height: this.state.headerHeight }} />
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        subId: state.subId,
        userName: state.userName,
        isLogged: sessionStorage.getItem('isLogged')
    };
}

export default (connect(mapStateToProps)(Header));